import React from "react";
import { findAllRolEvent } from "../../_events/roles/find.event";
import { alertError } from "../../_utils/alerts";

export const useAllRoles = () => {

    const [data, setData] = React.useState([]);

    const loadData = () => {
        findAllRolEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData();
    }, []);

    return { data, loadData };
}